import { useState, useEffect } from "react"
import Style from "./style"
import Wrapper from "../Wrapper"

import useThemeCookie from "shared/model/useThemeCookie"
import useLogoTransparency from "shared/model/useLogoTransparency"
import PrizeSlideshow from "shared/ui/PrizeSlideshow"
import useResponsiveTimer from "shared/hooks/useResponsiveTimer"
import FitText from "shared/ui/FitText"

const Normal = ({ elapsedTime, elapsedTimeDisplay, countDown, nextBreak, regClose, timeData, prizeData,
    infoData, logoImg, eventName, uploadImage, loading, eventData, wrapperRef, navigationBlock, setNavigationBlock, navigateWithConfirm }) => {
    const [themeCookie] = useThemeCookie()
    const [logoTransparency] = useLogoTransparency()
    const timerStyles = useResponsiveTimer(wrapperRef)
    const [isSplitView, setIsSplitView] = useState(window.innerWidth <= 1280)

    useEffect(() => {
        const handleResize = () => {
            setIsSplitView(window.innerWidth <= 1280)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const currentStyles = isSplitView ? timerStyles?.split : timerStyles?.full

    const split = countDown ? countDown?.split(":") : ["00", "00"]
    const isWarning = split[0] === "00" && parseInt(split[1]) <= 10 ? true : false
    const {prize_editor, duration, prize_list} = eventData?.data || {}

    return (
        <Wrapper title={eventName} infoData={infoData} logoImg={logoImg}
        timeData={timeData} countDown={countDown} eventData={eventData} prizeData={prizeData}
         prize_editor={prize_editor} prize_list={prize_list} duration={duration} ref={wrapperRef}
         navigationBlock={navigationBlock} setNavigationBlock={setNavigationBlock} navigateWithConfirm={navigateWithConfirm}>
            <Style.ContentDiv>
                <Style.TimerDiv $themeType={themeCookie}>
                    <Style.TimerInfo $warning={isWarning} $timerStyles={timerStyles}>
                        <Style.LogoCenter $themeType={themeCookie} $logoTransparency={logoTransparency}>
                            {logoImg && <img src={logoImg} alt="logo" onError={(e) => e.target.style.display = "none"} />}
                        </Style.LogoCenter>
                        <Style.TimerTopDiv $themeType={themeCookie}>
                            <h1>Level {timeData?.level}</h1>
                            <div>
                                <h2>Elapsed Time</h2>
                                <p>{elapsedTimeDisplay || "00:00"}</p>
                            </div>
                        </Style.TimerTopDiv>
                        <h1>{countDown || "00:00"}</h1>
                        <FitText as="h2" maxFontSize={parseInt(currentStyles?.h2?.fontSize) || 64} minFontSize={24}>
                            BLINDS {timeData?.sb} / {timeData?.bb} ({timeData?.ante})
                        </FitText>
                        {timeData?.next_level === "break"
                            ? <FitText as="h3" maxFontSize={parseInt(currentStyles?.h3?.fontSize) || 48} minFontSize={18}>NEXT BLINDS BREAK TIME</FitText>
                            : <FitText as="h3" maxFontSize={parseInt(currentStyles?.h3?.fontSize) || 48} minFontSize={18}>NEXT BLINDS {timeData?.next_sb} / {timeData?.next_bb} ({timeData?.next_ante})</FitText>
                        }
                        <Style.TimerBottomDiv $themeType={themeCookie}>
                            <div>
                                <h2>Next Break</h2>
                                <p>{nextBreak || "00:00"}</p>
                            </div>
                            <div>
                                <h2>Reg. Close</h2>
                                <p>{regClose || "00:00"}</p>
                            </div>
                        </Style.TimerBottomDiv>
                        <Style.LogoIcon $themeType={themeCookie} />
                    </Style.TimerInfo>
                </Style.TimerDiv>

                <Style.PrizeDiv>
                    <Style.PrizeListDiv>
                        <h2>Prize Pool</h2>
                        <PrizeSlideshow
                            prizeArray={prize_editor || []}
                            prizeList={prize_list || []}
                            duration={duration || 6000}
                            showIndicators={prize_editor && prize_editor.length > 1}
                        />
                    </Style.PrizeListDiv>
                    {prizeData?.total &&
                        <Style.TotlePrizeDiv>
                            <h2>Total Prize</h2>
                            <p>{prizeData?.total}</p>
                        </Style.TotlePrizeDiv>
                    }
                </Style.PrizeDiv>

            </Style.ContentDiv>

        </Wrapper >
    )
}

export default Normal
